import Accordion from "./Accordion";
import IconQuotes from "./IconQuotes";

export default function CardCarousel({item, className= ''}) {
    const hasLinks = item.links && item.links.length > 0;
    return (
        <div className={`relative flex flex-col rounded-[3rem] border-[0.25rem] border-[#e2e2e2] bg-[#09172b] ${className}`}>
            <div className="w-full
            px-[9rem] py-[8.375rem]
            border-b-[0.25rem] border-[#e2e2e2]
            font-light text-[3rem] leading-[5.5625rem]"
            dangerouslySetInnerHTML={{__html:item.review}}></div>
            <div className="absolute
            flex
            w-[7.375rem] h-[7.375rem] rounded-full
            border-[0.25rem] border-[#e2e2e2]
            bg-[#09172b]
            justify-center
            top-[7.375rem] left-0 -translate-x-1/2">
                <IconQuotes className="w-[3rem]" />
            </div>
            <div className="w-full flex">
                <div className=
                {`pl-[6.375rem]
                min-h-[25.125rem]
                items-center
                w-[54.27%] flex
                ${ hasLinks ? 'border-r-[0.25rem] border-[#14254a]' : ''}`}>
                    <img className="bg-white rounded-3xl w-[28.5rem] h-[13.5rem] mr-[5.5rem]"
                    src={`${process.env.PUBLIC_URL}/logos/${item.logo}`} />
                    <div>
                        <div className="font-medium text-[2rem]">{item.author}</div>
                        <div className="font-light text-[2rem]">{item.position}</div>
                    </div>
                </div>
                {hasLinks &&
                <div className="py-[4rem] flex-1 pl-[6.5rem] pr-[5.875rem]">
                    <Accordion items={item.links} />
                </div>
                }
            </div>
        </div>
    );
};